/** @jsx jsx */
import { jsx } from "@emotion/core";
import * as React from "react";
import { responsiveStyles } from "../../commons/styles";
import { signinText, countryCodes, GAEvents } from "../../constants/commons";
import OtpInput from "react-otp-input";
import { otpInputFieldStyle } from "./styles";
import { CountdownTimer } from "../CountdownTimer";
import { IOTPInputFieldProps } from "./interfaces";
import useSTR from "react-str";
import { postData } from "../../utils/fetchers";
import { URL } from "../../API/urlEndpoints";
import { Spin } from "antd";
import { OtpVerificationRequest } from "../../commons/interfaces";
import { GA_Event } from "../../utils/reactGA";

export const OTPInputField: React.FC<IOTPInputFieldProps> = (
  props: IOTPInputFieldProps
) => {
  // [POST] For Sending Enetered OTP
  const [
    ,
    {
      result: onSuccessfullOTP,
      revalidator: refetchSendEnteredOTP,
      loading: loadingOTPPost,
      error: errorOTPPost,
    },
  ] = useSTR(postData);

  const {
    onGoBackClick,
    phoneNumber,
    onSignInClick,
    onResendOTP,
    hasErrorOccured,
  } = props;
  const [otp, setOtp] = React.useState<string>();
  const [resendOTP, setResendOTP] = React.useState<boolean>(false);
  const [disbaleOTPReqButton, setDisbaleOTPReqButton] = React.useState<boolean>(
    true
  );

  React.useEffect(() => {
    if (errorOTPPost) {
      errorOTPPost && hasErrorOccured && hasErrorOccured(errorOTPPost);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorOTPPost]);

  const onSigninClick = () => {
    GA_Event(GAEvents.SIGN_IN_OTP, "clicked", "sign up last step");
    let otpVerificationObj: OtpVerificationRequest = {
      otp: otp || "",
      phone: {
        countryCode: countryCodes.INDIA,
        number: phoneNumber || "",
      },
    };
    otp && refetchSendEnteredOTP(`${URL.postsendOTP}`, otpVerificationObj);
  };

  React.useEffect(() => {
    if (!errorOTPPost && onSuccessfullOTP && onSuccessfullOTP.success) {
      onSignInClick("Success!");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onSuccessfullOTP, errorOTPPost]);

  const onOTPChange = (enteredOTP: string) => {
    setOtp(enteredOTP);
  };
  const onCountDownEnd = (value: number) => {
    if (value === 1) {
      setResendOTP(false);
      setDisbaleOTPReqButton(false);
    }
  };

  const onResendOTPClick = () => {
    GA_Event(GAEvents.RESEND_OTP, "clicked", "sign up last step");
    setDisbaleOTPReqButton(true);
    setResendOTP(true);
    setOtp(undefined);
    onResendOTP();
  };

  return (
    <span css={[responsiveStyles, otpInputFieldStyle]}>
      {loadingOTPPost ? (
        <Spin size="large" />
      ) : (
        <div className="row no-gutters responsive-dimensions-container my-5">
          <div className="d-flex align-items-center justify-content-center w-100">
            <div className="m-2 heading-style text-center">Enter OTP</div>
          </div>

          <div className="w-100 text-center">
            <div className="d-flex justify-content-center">
              <div>Enter OTP sent to {phoneNumber}</div>
              <button
                className="border-0 bg-white edit-button-style user-button-style"
                onClick={onGoBackClick}
              >
                EDIT
              </button>
            </div>

            <div className="m-2 justify-content-center">
              <OtpInput
                value={otp}
                inputStyle="otp-style"
                onChange={onOTPChange}
                numInputs={6}
                containerStyle="container-otp"
                isInputNum={true}
              />

              {disbaleOTPReqButton && (
                <CountdownTimer
                  start={5}
                  count={onCountDownEnd}
                  restartTimer={resendOTP}
                />
              )}

              <button
                onClick={onResendOTPClick}
                disabled={disbaleOTPReqButton}
                className="border-0 bg-white resend-button-style user-button-style my-3"
              >
                Resend
              </button>
            </div>

            <div className="">
              <button
                className="button-style-red responsive-button-width user-button-style"
                onClick={onSigninClick}
                disabled={!otp}
              >
                <span className="responsive-text">{signinText}</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </span>
  );
};
